/* eslint-disable @typescript-eslint/ban-ts-comment */
/* eslint-disable @typescript-eslint/no-explicit-any */
import { useCallback, useState, useEffect } from "react";
import { InlineEdit } from "../../components/InlineEdit";
import { Button } from "../../components/Button";
import { useParams } from "react-router-dom";
import getCroppedImg from "../../utils/cropImage";
import useSaveTemplate from "../../utils/customHooks";
import ImageUploader from "../../utils/ImageUploader";
import { CropperWrapper } from "../../utils/CropperWrapper";
import { SpinnerOverlay } from "../../utils/SpinnerOverlay";

const Basnie3: React.FC = () => {
  const { pdfNameFromUrl } = useParams<{ pdfNameFromUrl: string }>();
  const [text1, setText1] = useState<string>("Bajeczki księżniczki");
  const [text2, setText2] = useState<string>("Matyldy");
  const [text3, setText3] = useState<string>("Na pamiątkę Chrztu Świętego");
  const [text4, setText4] = useState<string>("Matka Chrzestna");
  const [fontSizeText1, setFontSizeText1] = useState<number>(53);
  const [fontSizeText2, setFontSizeText2] = useState<number>(78);
  const [fontSizeText3, setFontSizeText3] = useState<number>(31);
  const [fontSizeText4, setFontSizeText4] = useState<number>(31);
  const [image, setImage] = useState<string | null>(null);
  const [croppedImage, setCroppedImage] = useState<string | null>(null);
  const [crop, setCrop] = useState<{ x: number; y: number }>({ x: 0, y: 0 });
  const [zoom, setZoom] = useState<number>(1);
  const [croppedAreaPixels, setCroppedAreaPixels] = useState<any>(null);
  const [step, setStep] = useState<"select" | "crop" | "view">("select");
  const { saveTemplate, isSaving } = useSaveTemplate();

  const pdfWidth = "250mm"; // PDF width in mm
  const pdfHeight = "300mm"; // PDF height in mm
  const maxWidth = 550; // Max width for resizing text

  const adjustFontSize = (
    text: string,
    currentFontSize: number,
    maxFontSize: number,
    minFontSize: number,
  ) => {
    const canvas = document.createElement("canvas");
    const context = canvas.getContext("2d");

    if (context) {
      let newFontSize = currentFontSize;
      context.font = `${newFontSize}px DemoConeriaScript`;
      let textWidth = context.measureText(text).width;

      while (textWidth > maxWidth && newFontSize > minFontSize) {
        newFontSize -= 1;
        context.font = `${newFontSize}px DemoConeriaScript`;
        textWidth = context.measureText(text).width;
      }

      while (textWidth < maxWidth * 0.9 && newFontSize < maxFontSize) {
        newFontSize += 1;
        context.font = `${newFontSize}px DemoConeriaScript`;
        textWidth = context.measureText(text).width;
      }

      return newFontSize;
    }

    return currentFontSize;
  };

  useEffect(
    () => setFontSizeText1(adjustFontSize(text1, fontSizeText1, 53, 12)),
    [text1],
  );
  useEffect(
    () => setFontSizeText2(adjustFontSize(text2, fontSizeText2, 78, 18)),
    [text2],
  );
  useEffect(
    () => setFontSizeText3(adjustFontSize(text3, fontSizeText3, 31, 12)),
    [text3],
  );
  useEffect(
    () => setFontSizeText4(adjustFontSize(text4, fontSizeText4, 31, 12)),
    [text4],
  );

  const handleCropComplete = useCallback((croppedArea: any, croppedAreaPixels: any) => {
    setCroppedAreaPixels(croppedAreaPixels);
  }, []);

  const handleShowCroppedImage = useCallback(async () => {
    if (image && croppedAreaPixels) {
      // Function to crop the image and get the result
      const croppedImg = await getCroppedImg(image, croppedAreaPixels); // Replace with your image cropping logic
      setCroppedImage(croppedImg);
      setStep("view");
    }
  }, [image, croppedAreaPixels]);

  const handleSave = () => {
    saveTemplate(
      "printable-content",
      {
        pdfWidth: pdfWidth,
        pdfHeight: pdfHeight,
        pdfNameFromUrl: pdfNameFromUrl,
      },
      croppedImage,
      true
    );
  };

  return (
    <div style={{
      width: "100%",
      height: "100%",
      backgroundColor: "#ffffff", padding: "80px",
      position: "relative",
    }}>
      {/* Spinner Overlay */}
      <SpinnerOverlay isVisible={isSaving} />
      <div style={{ position: "absolute", top: "10px", left: "0px", right: "0px", margin: "auto", color: "white", width: "480px", maxWidth: "100%", height: "70px", gap: "30px", display: "flex", alignItems: "center" }}>
        <ImageUploader
                onImageChange={(image) => setImage(image)}
                setStep={setStep}
              />
              {step === "crop" && (
                <p>
                  Aby wykadrować zdjęcie możesz kręcić kółkiem myszy i przesuwać obraz
                </p>
              )}
              <div style={{ }}>
                {step !== "crop" && (
                  <Button onClick={handleSave} disabled={isSaving}>
                    {isSaving ? "Zapisywanie..." : "Zapisz"}
                  </Button>
                )}
                {step === "crop" && (
                  <Button onClick={handleShowCroppedImage}>Zakończ kadrowanie</Button>
                )}
              </div>
      </div>

      <div
        className="bg-white basnie-3"
        id="printable-content"
        style={{
          position: "relative",
          width: "250mm",
          height: "300mm",
          fontFamily: "DemoConeriaScript, BarlowThin, BarlowMedium",
        }}
      >
        <InlineEdit
          value={text1}
          setValue={setText1}
          classes="basnie3-gradient-text-1"
          style={{
            fontSize: `${fontSizeText1}px`,
            fontFamily: "DemoConeriaScript",
          }}
        />
        <InlineEdit
          value={text2}
          setValue={setText2}
          classes="basnie3-gradient-text-2"
          style={{
            fontSize: `${fontSizeText2}px`,
            fontFamily: "DemoConeriaScript",
          }}
        />
        <InlineEdit
          value={text3}
          setValue={setText3}
          classes="basnie3-gradient-text-3"
          style={{ fontSize: `${fontSizeText3}px`, fontFamily: "BarlowThin" }}
        />
        <InlineEdit
          value={text4}
          setValue={setText4}
          classes="basnie3-gradient-text-4"
          style={{ fontSize: `${fontSizeText4}px`, fontFamily: "BarlowMedium" }}
        />
        {/* Step: Crop */}
      {image && step === "crop" && (
        <CropperWrapper
          image={image}
          crop={crop}
          zoom={zoom}
          cropShape="round"
          aspect={97 / 121}
          onCropChange={setCrop}
          onZoomChange={setZoom}
          onCropComplete={handleCropComplete}
          style={{
            top: "86mm",
            left: "51.5%",
            width: "97mm",
            height: "117mm",
          }}
        />
      )}

      {/* Step: View */}
      {croppedImage && step === "view" && (
        <img
          src={croppedImage}
          style={{
            position: "absolute",
            top: "86.5mm",
            left: "51.5%",
            width: "97mm",
            height: "117mm",
            transform: "translateX(-50%)",
            borderRadius: "50%",
            zIndex: 2,
          }}
        />
      )}

        <img
          src="/images/Basnie3.svg"
          style={{
            position: "absolute",
            zIndex: 5,
            width: "100%",
            height: "100%",
          }}
        />
        <img
          className="wzor-25-bg"
          src="/images/Basnie3_background.svg"
          style={{ width: "100%", height: "100%" }}
        />
      </div>
    </div>
  );
};

export default Basnie3;
